import { render, staticRenderFns } from "./auto-form-lite.vue?vue&type=template&id=3c79b432&scoped=true&"
import script from "./auto-form-lite.vue?vue&type=script&lang=js&"
export * from "./auto-form-lite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79b432",
  null
  
)

export default component.exports